module.exports = __webpack_public_path__ + "static/heroslide-3-182bcc009828636eaef2d584a068844d.jpeg";